/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import SearchIcon from 'icons/SearchIcon';

const messages = defineMessages({
  title: {id: 'navigation.search'},
});

const SearchItem = () => (
  <RouteLinkItem
    iconBefore={SearchIcon}
    route="midas/guardians/search"
    title={messages.title}
  />
);

export default SearchItem;
